__turbopack_context__.v({
  "currentRefinementsLabel": "CurrentRefinements-module-scss-module__vcGQ_G__currentRefinementsLabel",
  "deleteIcon": "CurrentRefinements-module-scss-module__vcGQ_G__deleteIcon",
  "isProductLine": "CurrentRefinements-module-scss-module__vcGQ_G__isProductLine",
  "swatch": "CurrentRefinements-module-scss-module__vcGQ_G__swatch",
});
